var _defs, _path, _b, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "157px",
    height: "152px",
    viewBox: "-0.5 -0.5 157 152",
    content: "<mxfile host=\"Electron\" modified=\"2020-04-28T10:37:26.164Z\" agent=\"Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_3) AppleWebKit/537.36 (KHTML, like Gecko) draw.io/12.1.0 Chrome/76.0.3809.139 Electron/6.0.7 Safari/537.36\" etag=\"4BYtJjbYFwRGHkA1pmKf\" version=\"12.1.0\" type=\"device\" pages=\"3\"><diagram id=\"ga9zrOOZ4fvBvmJUR_HY\" name=\"Page-1\">rZVNj5swEIZ/DVJ7oAIcSHJckrTpoVKltOrZAQesNTbrmJL013cG2wGSXakrlRwwz3zYM/NCArJpLl80betvqmQiSKLyEpBtkCRxmhK4Ibk6Ei9WllSal46N4MD/MAcjRztesvPM0SglDG/nsFBSssLMGNVa9XO3kxLzXVtasQdwKKh4pL94aWpLV8ly5HvGq9rvHGdra2mod3aVnGtaqn6CyC4gG62UsavmsmECu+f7YuM+v2G9HUwzaf4lwKR9J/c/d02nNkbTPQ1fWOiy/KaicwW7w5qr7wCcu8VlzS60UjIgecs0b5hheqTfPYKy8r7mhh1aWmBYD8IAVptGwFMMS60MNRwzbcM4xYCzHXv0KSFZtlxFKxIvSZotMrQZrZ5vvQdZkPzEhdgoofRwQHJK8XdznViy4cIIJc2E2wu4q55pwy5vtjW+DQtkzhSUqa/g4gPWCxviFJ4snOT7US6xV3M9kcravQjUKbS6pR6HCAs3x3fMlLwy00wYbFBL5Wy42UuH8ssL25snMOrq+CGFkmHvaLx/HJoVYR/DE224uFpvSEEbnK9LZEAFZ+CS9ZhLNbjh3GWSyc4d86yi9mINMAkTUsEraS0FzAGVhrZBWOHZKguNUumGisHoS4FV5e5DzUcPvnoCTT3eewGzzfH47iXAU92pmMHp6XFwQFG2ikszjDLNg3QLhHZGOWVjgKtpK9gJU6HoOHxnnhw2qrUTKrisfuDDNlwAEfTIRE6L50qrTpZexVJJ9n8EnJDkTsDRg4DTV/Tr3d6hX3gcv3eDbfK3QXZ/AQ==</diagram><diagram name=\"Page-2\" id=\"TcW29Igzi0AjpmyGTZhy\">tVXbjtowEP2aSO0DVRJDCI9ctu1KXakqq27VN5OYxFrHzjpmE/brOxPbhMBKFVILEhmfudhz5jgEZF11XzStyweVMxHEYd4FZBPE8YLE8IvA0QJJurBAoXluoWgAtvyNOTB06IHnrBkFGqWE4fUYzJSULDMjjGqt2nHYXonxrjUt2BWwzai4Rp94bkqLpvF8wL8yXpR+5yhx/VXUB7tOmpLmqj2DyF1A1lopY62qWzOB3HleHrrm6e1b8rtdPqrm+PMlfv3xa2KLfb4l5dSCZtL829JuuK9UHBxfrldz9ARC2zWaJetooWRAVjXTvGKG6QH97iFgZdWW3LBtTTNMa0FVgJWmErCKwNTKUMOx0mYSzTChsaoJP8UkSeZpmJJoTmbJNEGf0er5NDpQFVntuRBrJZTuD0j2M/yeQs88Sf/BDCXNGW4/gLvumTasu5DLX7iOTgKAi8MU9K6PkOerLKa2jrs08ZTYdTtIMPI3pDyT3yJ1yneqL06lh8mC4YZ7w6DJO4NOhEHWaipHE09eDijpVWYJW4JTF7sPM2gZTgzbhyPzI9pIZYgsT/a04uJo06AWrereScgUngZE0oBDsharqgq3vogZl7PSwGJpWHcnH8zLTKjghbTODKYFevTuXoGTxkoQ/VLpioqhN7AK9+xJ2Hng/t5DQPPuMgwwS5eHL+4KHutC7Aw6oLs+AA9XKy5NP9zZKphtAKEHo9wFwATX1EawPZZCbXJ4my0dbFRtZ5ZxWTziYjNB1gTdMbGi2XOh1UHmXuxSSfYfdR5HyYXOwyudp+/I3IfdIHNYDq/a3nf2f0Xu/gA=</diagram><diagram name=\"Page-3\" id=\"VOXg0mpcBz3pXAeHblec\">tVXbjpswEP0apPaBCnAgyeMm2W0jtVKlbbX76oAD7hqbGqeQfn1nsA0hW6mN1CZSGJ+52HPmmARkW/fvNW2qT6pgIkiiog/ILkiSNUngF4GzBbLV2gKl5oWF4gl45D+ZAyOHnnjB2lmgUUoY3szBXEnJcjPDqNaqm4cdlZjv2tCSvQIecypeo0+8MJVFV8lywj8wXlZ+5zhz/dXUB7tO2ooWqruAyH1AtlopY6263zKB3Hle9u3Hp/45FWFN+3PyzTxUX9PQFnu4JWVsQTNp/m1pN9wfVJwcX65Xc/YEQtsNmhXraalkQDYN07xmhukJ/ewhYGXTVdywx4bmmNaBqgCrTC1gFYOplaGGY6VdGKeY0FrVRO8SkmXLVbQi8ZKk2SJDn9HqZRwdqIpsjlyIrRJKDwckxxS/Y+iFJxs+mKGkucDtB3DXPdOG9Vdy+QPX8SgAuDhMQe/6DHm+ynph67hLkyyIXXeTBGN/Q6oL+a1XTvlO9eVYeposGG64Nwya/GbQmTDIWkPlbOLZ9xNKepNbwu7AqcvDmxRahhPD9tHMfIs2Uhkhy+GR1lycbRrUonUzOAlZwNOASFpwSNZhVVXj1lcx83JWGlhsFTX96IN5mZAKXkrrzGFaoEfvHhQYtlaC6JdK11RMvYFVuudAwsED+/3eY8Dz4ToOMMuXh68uC57rSu0MWqCHIQBP1yguzTDddBOkO0DoySh3AzDBdbUT7IilUJwcXmd3DjaqsUPLuSy/4GIXIm2CHpjY0Pyl1OokC692qST7j0JPovhK6NHfCd3H3SB0WE4v28F38Y9F7n8B</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 49.03 26 L 106.97 26 L 133 75 L 106.97 124 L 49.03 124 L 23 75 Z",
    fill: "#f5f5f5",
    stroke: "#666666",
    strokeWidth: 10,
    strokeMiterlimit: 10,
    transform: "rotate(-152,78,75)",
    pointerEvents: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.5,25.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    style: {
      overflow: "visible"
    },
    pointerEvents: "none",
    width: 93,
    height: 94,
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      verticalAlign: "top",
      whiteSpace: "nowrap",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "inline-block",
      textAlign: "inherit",
      textDecoration: "inherit"
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: "rgb(51 , 51 , 51)",
      fontFamily: "&quot",
      fontSize: 80,
      textAlign: "center",
      whiteSpace: "normal"
    }
  }, _b || (_b = /*#__PURE__*/React.createElement("b", null, "III")))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 47,
    y: 53,
    fill: "#000000",
    textAnchor: "middle",
    fontSize: "12px",
    fontFamily: "Helvetica"
  }, "[Not supported by viewer]"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step-3.f5c1d2e52e6dd05629acf4069352654d.svg";
export { ForwardRef as ReactComponent };